import { useEffect, useState } from 'react'

function Ospiti({ ospiti }) {

    const [arrOspiti, setArrayOspiti] = useState({ nomi: [], dettagli: [], alt: null })

    const dettagliOsp = (e) => {
        const as = document.getElementById('dettagliOsp')
        if (arrOspiti.dettagli[e] !== undefined) {//se l'ospite ha il dettaglio
            as.style.display = 'block'
            as.innerHTML = `<span style="cursor:pointer">❎</span> ${arrOspiti.dettagli[e]}`
            document.addEventListener('mouseup', (nascondiDiv))
            function nascondiDiv() {
                document.getElementById('dettagliOsp').style.display = 'none'
                document.removeEventListener('mouseup', nascondiDiv)
            }
            switch (e) {//calcolo top nello style del div 
                case 0: setArrayOspiti({ ...arrOspiti, alt: '45%' }); break
                case 1: setArrayOspiti({ ...arrOspiti, alt: '60%' }); break
                case 2: setArrayOspiti({ ...arrOspiti, alt: '75%' }); break
                case 3: setArrayOspiti({ ...arrOspiti, alt: '90%' }); break
                case 4: setArrayOspiti({ ...arrOspiti, alt: '100%' }); break
                default:
            }
        }
    }

    useEffect(()=>{
         if (ospiti) {
            const we = ospiti.split('ç')
            let z = {}//oggetto contenente 0:[nome ospite, descrizione] 1:[nome ospite, descrizione] ecc
            let x = []//array per ottenere solo il nome degli ospiti
            let y = []//array per ottenere i dettagli degli ospiti
            we.forEach((e, index) => {
                z = { ...z, [index]: e.split('%') }
            })

            //separo i nomi degli ospiti e i dettagli
            Object.values(z).forEach((e) => {
                x.push(e[0])//nomi
                y.push(e[1])//dettagli
            })
            setArrayOspiti({ nomi: x, dettagli: y })
        }
    },[ospiti])

    return (<>
        <div style={{ margin: '2em 0 0 0', position: 'relative' }}>
            <h2 className='text-center mt-3'>OSPITI DELL'EVENTO ⭐</h2><br />
            {arrOspiti.nomi.map((elem, index) => (
                <p key={index} className='ospiti' onClick={() => { dettagliOsp(index) }}>
                    ▪ {elem}
                </p>
            ))}
            <br />
            <div id='dettagliOsp' style={{
                display: 'none', position: 'absolute', backgroundColor: 'whitesmoke', top: arrOspiti.alt, left: '0', right: '0', margin: 'auto', transition: '.3s',
                width: '80%', height: 'auto', padding: '1rem', zIndex: '1', borderRadius: '10px', border: '1px solid grey', textAlign: 'center'
            }}>
                <img src={require('../../image/icons8-chiudi-macos-32.png')} alt='' />
            </div>
        </div>
    </>)
}
export default Ospiti